// Pick the right-sized variant of an uploaded asset.
//
// Objects carry `url` (the ORIGINAL, i.e. the `large` variant) plus a `urls`
// array of { size, url, w, h } for "large" | "medium" | "small". Rendering the
// original into a ~150px footer thumbnail makes the browser decode the full
// image: a 16042x8335 clipart PNG is 133 megapixels, ~510MB decoded, and this
// theme uses one 16 times. The footer renders every page at once, so those
// decodes blocked the main thread for seconds and starved footer page
// drag-and-drop of `dragover` events (drag looked dead until the stall passed).
//
// preview/Photo.jsx already did this for photos (`size="small"`); stickers did
// not, which is why only sticker-heavy themes broke. This is the shared version.
// `size` is OPT-IN: with no size (or an unknown one) this returns `item.url`
// (the original), exactly what a caller rendered before it was given a size.
// It never silently downgrades a surface that did not ask.
//
// Current callers of preview/Sticker.jsx, all explicit:
//   footer thumbnails (~150px)        -> "small"
//   Ideas panel thumbnails            -> "small"
//   3D product previews (book/fold/wall) -> "large"
// The main canvas and the export renderer are separate components and do not
// go through here; export always paints the original, so print is unaffected.
export const pickImageVariant = (item, size) => {
  const fallback = item?.url || "";
  if (!["large", "medium", "small"].includes(size)) return fallback;
  const variants = item?.urls;
  if (!Array.isArray(variants) || variants.length === 0) return fallback;
  const match = variants.find((v) => v?.size === size);
  return match?.url || fallback;
};

export default pickImageVariant;
